import { Component } from '@angular/core';

@Component({
    selector: 'rk-alarm-configuration',
    templateUrl: './alarm-configuration.component.html',
    styleUrl: './alarm-configuration.component.scss',
    standalone: false
})
export class AlarmConfigurationComponent {}
